module.exports = __webpack_public_path__ + "img/qrcode.805cf6c6.png";